export default __webpack_public_path__ + "static/media/bgguard.4340680b.jpg";